module.exports = __webpack_public_path__ + "images/play-mechanix-6b864fd40e062cb1f9b88245ec7dbc4d.png";